export default "__VITE_PUBLIC_ASSET__c99daed2__"